<template>
  <el-tooltip
    v-bind="$attrs"
  >
    <slot />
    <template #content>
      <div class="hct-popover-line">
        <slot name="content" />
      </div>
    </template>
  </el-tooltip>
</template>

<script setup>
// import {defineComponent, reactive, toRefs} from 'vue'

</script>
<script>
export default {
  name: "HctPopover",
};
</script>
<style scoped lang='scss'>
  .hct-popover-line {
    -webkit-line-clamp:2;
    display: -webkit-box;
    -webkit-box-orient:vertical;
    overflow:hidden;
    text-overflow: ellipsis;
    box-shadow: 0px 2px 4px 1px rgba(0,0,0,0.16);
  }
</style>
